import { FaqList } from "@/components/FAQ";
import { FAQS } from "@/data/faq";
import { CLINIC } from "@/data/clinic";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Reveal from "@/components/Reveal";
import Seo from "@/components/Seo";
import { Phone } from "lucide-react";

const TITLE = "Frequently Asked Questions | Agastya Chiro and Ancient Marma Therapy";
const DESC =
    "Honest answers about Marma Chikitsa — what it is, safety, what happens in a session, and how to book at Agastya Chiro and Ancient Marma Therapy, Kurnool. Call 89781 33934.";

const faqJsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: FAQS.map((f) => ({
        "@type": "Question",
        name: f.q,
        acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
};

export default function FaqPage() {
    return (
        <div className="bg-cream text-ink" data-testid="faq-page">
            <Seo title={TITLE} description={DESC} path="/faq" jsonLd={faqJsonLd} />
            <Header />
            <main className="mx-auto max-w-4xl px-4 pb-24 pt-36 sm:px-6 md:pt-44">
                <Reveal>
                    <p className="text-xs font-semibold uppercase tracking-[0.28em] text-terracotta">FAQ</p>
                    <h1
                        className="mt-4 font-serif text-4xl font-medium leading-[1.05] tracking-tight md:text-5xl"
                        data-testid="faq-page-heading"
                    >
                        Frequently Asked Questions
                    </h1>
                    <p className="mt-5 max-w-2xl text-sm leading-relaxed text-moss md:text-base">
                        Straight answers about Marma Chikitsa and visiting our Kurnool wellness centre.
                        For anything else, call or WhatsApp us on {CLINIC.phoneDisplay}.
                    </p>
                </Reveal>

                <div className="mt-12">
                    <FaqList />
                </div>

                <Reveal>
                    <div className="mt-14 flex flex-wrap items-center justify-between gap-6 rounded-3xl bg-forest p-8 text-cream md:p-10">
                        <div>
                            <h2 className="font-serif text-2xl font-medium md:text-3xl">Still have a question?</h2>
                            <p className="mt-2 text-sm text-cream/80">
                                A quick call is the easiest way to ask. {CLINIC.hours.weekdays}.
                            </p>
                        </div>
                        <a
                            href={CLINIC.phoneTel}
                            data-testid="faq-page-call-btn"
                            className="inline-flex items-center gap-2 rounded-full bg-cream px-6 py-3 text-sm font-semibold text-ink transition-[background-color,transform] duration-300 hover:-translate-y-0.5 hover:bg-gold"
                        >
                            <Phone className="h-4 w-4" /> Call {CLINIC.phoneDisplay}
                        </a>
                    </div>
                </Reveal>
            </main>
            <Footer />
        </div>
    );
}
